const CLOSED_DAYS = new Set(['Sat', 'Sun']);
const OPEN_TIME_MINUTES = 8 * 60 + 30; // 8:30
const CLOSE_TIME_MINUTES = 19 * 60; // 19:00

const italyFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Europe/Rome',
  hour: 'numeric',
  minute: 'numeric',
  hour12: false,
  weekday: 'short',
});

export const isCallCenterOpen = (now = new Date()): boolean => {
  const parts = italyFormatter.formatToParts(now);

  const weekday = parts.find(p => p.type === 'weekday')?.value ?? '';
  if (CLOSED_DAYS.has(weekday)) return false;

  const hour = Number(parts.find(p => p.type === 'hour')?.value ?? 0);
  const minute = Number(parts.find(p => p.type === 'minute')?.value ?? 0);
  const currentMinutes = hour * 60 + minute;

  return currentMinutes >= OPEN_TIME_MINUTES && currentMinutes < CLOSE_TIME_MINUTES;
};
